<script setup>

const gallerySwiper = ref(null)

const swiper = useSwiper(gallerySwiper, {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 32,
	centeredSlides: true,
	allowTouchMove: false,
	simulateTouch: false
})

const activeSlide = ref(1)
const sliding = ref(false)

const props = defineProps({
  items: {
    type: Array,
  }
})

const slidedItems = ref([])

onMounted(() => {
	let items = [...props.items]

	const lastItem = items.pop()

	items = [lastItem, ... items]
	slidedItems.value = items

	nextTick(() => {
		swiper.next()
	})
})

const nextSlide = () => {
	sliding.value = true
	activeSlide.value = activeSlide.value === props.items.length ? activeSlide.value = 1 : activeSlide.value += 1
	swiper.next()
	
	setTimeout(() => {
		sliding.value = false
	},200)
}

const prevSlide = () => {
	sliding.value = true
	activeSlide.value = activeSlide.value === 1 ? activeSlide.value = props.items.length : activeSlide.value -= 1
	swiper.prev()

	setTimeout(() => {
		sliding.value = false
	},200)
}

</script>

<template>
	<div class="relative mb-10 xl:mb-20">

		<ClientOnly>
			<swiper-container ref="gallerySwiper">
				<swiper-slide
					v-for="(slide, idx) in slidedItems"
					:key="idx"
				>
					<div class="aspect-[870/655] carousel__item bg-cover bg-no-repeat bg-center" :style="{ backgroundImage: `url(${slide.url})` }"></div>
				</swiper-slide>
			</swiper-container>
		</ClientOnly>
		<div v-if="swiper" class="absolute h-full w-[50%] top-0 left-[50%] -translate-x-[50%] z-10">
			<div class="absolute top-[47%] -left-28 z-30">
				<button @click="prevSlide()" :disabled="sliding">
					<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
						<circle cx="32" cy="32" r="30.5" transform="matrix(-1 0 0 1 64 0)" stroke="#F5F5F5" stroke-width="3"/>
						<path d="M22 32H41.9999" stroke="#F5F5F5" stroke-width="3"/>
						<path d="M29.5 24L21.5 32L29.5 40" stroke="#F5F5F5" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
					</svg>
				</button>
			</div>
			<div class="absolute top-[47%] -right-28 z-30">
				<button @click="nextSlide()" :disabled="sliding">
					<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
						<circle cx="32" cy="32" r="30.5" stroke="#F5F5F5" stroke-width="3"/>
						<path d="M42 32H22.0001" stroke="#F5F5F5" stroke-width="3"/>
						<path d="M34.5 24L42.5 32L34.5 40" stroke="#F5F5F5" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
					</svg>
				</button>
			</div>
			<div class="absolute top-[100%] left-4 dark:text-lightText text-base xl:text-lg">
				<span class="block mt-3">{{ `${activeSlide} / ${items.length}` }}</span>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.carousel__item {
	width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.swiper-slide-active {
	transition: opacity 0.5s ease-in-out;
	opacity: 1;
}

.swiper-slide-prev, .swiper-slide-next {
	transition: opacity 0.3s ease-in-out;
	opacity: 0.4;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}
</style>